<template>
  <div class="salary">
    <div class="customer-info">
      <div class="customer-info-item" >
        <div class="customer-info-title">
          <!--图标-->
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-qiyexinxi"></use>
          </svg>
          <span>计薪周期设置</span>
        </div>
        <div class="filter-container">
          <el-link type="primary" @click="showCustPaysetAddList" >添加</el-link>
        </div>
      </div>
      <div class="bsp-table" style="padding:10px 40px">
        <bsp-table
        auto-resize
        ref="cusPaysetTable"
        :showPagination="false"
        :data.sync="list"
        min-height="200"
        :ciic-data-filter.sync="listQuery"
        v-loading="loading"
        @ciic-data-refresh="_getCusPaysetListpage"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        show-overflow>
        <!-- <vxe-table-column type="selection" width="60" fixed="left" ></vxe-table-column> -->
        <vxe-table-column fixed="left" type="index" title="序号" width="60" ></vxe-table-column>
        <bsp-table-column field="calpaydateStartEnd" title="计薪周期"  ><!--:showPagination="false"-->
          <template slot-scope="scope">
            <span style="word-spacing:10px;">{{scope.row.calpayStartMonth |bspTableFilter({'1':'dict', '2':dicts})}}{{scope.row.calpayStartDay}}日 至
            {{scope.row.calpayEndMonth |bspTableFilter({'1':'dict', '2':dicts})}}{{scope.row.calpayEndDay}}日
            </span>
          </template>
        </bsp-table-column>
        <bsp-table-column field="socMonth" title="对应社保月份" >
          <template slot-scope="scope">
            <span>{{scope.row.socMonth |bspTableFilter({'1':'dict', '2':dicts})}}</span>
          </template>
        </bsp-table-column>
        <bsp-table-column field="payDate"  title="发薪日期">
          <template slot-scope="scope">
            <span>{{scope.row.payMonth |bspTableFilter({'1':'dict', '2':dicts})}}{{scope.row.payDay}}日</span>
          </template>
        </bsp-table-column>
          <bsp-table-column field="payGroupId" title="所属薪酬组" >
          <template slot-scope="scope">
            <span>{{ scope.row.payGroupId | bspTableFilter({'1':'refs','3':payGroupMap}) }}</span>
          </template>
        </bsp-table-column>
        <bsp-table-column title="操作" fixed="right" width="150" align="center"><!--fixed="left"-->
          <template slot-scope="scope">
            <div class="ciic-table-operate" >
              <el-button type="text"   @click="cusPaysetEditRow(scope.row)">编辑</el-button>
              <el-button type="text"   @click="cusPaysetDeleteRow(scope.row)">删除</el-button>
            </div>
          </template>
        </bsp-table-column>
      </bsp-table>
      </div>

    </div>

    <div class="customer-info">
      <div class="customer-info-item">
        <div class="customer-info-title">
          <!--图标-->
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-qiyexinxi"></use>
          </svg>
          <span>发薪银行设置</span>
        </div>
        <div class="filter-container">
             <el-link type="primary" @click="showCustPaybanksetAddList" >添加</el-link>
        </div>
    </div>
  <div class="bsp-table" style="padding:10px 40px">
      <bsp-table
         auto-resize
        ref="custPaybanksetTable"
        :data.sync="cusPaybanksetList"
        v-loading="loading"
         :showPagination="false"
        min-height="200"
        @ciic-data-refresh="_getCusPaybanksetListpage"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        show-overflow>
        <!-- <vxe-table-column type="selection" width="60" fixed="left" ></vxe-table-column> -->
        <vxe-table-column fixed="left" type="index" title="序号" width="60" ></vxe-table-column>
        <bsp-table-column field="payerName" title="开户名"   ><!--:showPagination="false"-->
          <template slot-scope="scope">
            <span>{{ scope.row.payerName }}</span>
          </template>
        </bsp-table-column>
        <bsp-table-column field="payerBankType" title="银行类别" set-id="3151">
          <template slot-scope="scope">
            <span>{{ scope.row.payerBankType | dictFilter(dicts) }}</span>
          </template>
        </bsp-table-column>
        <bsp-table-column field="payerBankAccount"  title="开户行账号">
          <template slot-scope="scope">
            <span>{{ scope.row.payerBankAccount }}</span>
          </template>
        </bsp-table-column>
        <bsp-table-column field="payerBankFullname" title="开户银行全称" >
          <template slot-scope="scope">
            <span>{{ scope.row.payerBankFullname }}</span>
          </template>
        </bsp-table-column>
        <bsp-table-column field="ifDefault"  title="默认发薪银行" set-id="1002">
          <template slot-scope="scope">
            <span>{{ scope.row.ifDefault | dictFilter(dicts) }}</span>
          </template>
        </bsp-table-column>
        <bsp-table-column field="orgId" title="所属机构" >
          <template slot-scope="scope">
            <span>{{ scope.row.orgId | bspTableFilter({'1':'refs','3':orgMap})}}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column title="操作" fixed="right" width="150" align="center"><!--fixed="left"-->
          <template slot-scope="scope">
            <div class="ciic-table-operate" >
              <el-button type="text"   @click="cusPaybanksetEditRow(scope.row)">编辑</el-button>
              <el-button type="text"   @click="cusPaybanksetDeleteRow(scope.row)">删除</el-button>
            </div>
          </template>
        </bsp-table-column>
      </bsp-table>
  </div>
    </div>

    <div class="customer-info">
      <div class="customer-info-item" >
        <div class="customer-info-title">
          <!--图标-->
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-qiyexinxi"></use>
          </svg>
          <span>公司税务信息设置</span>
        </div>

        <div class="filter-container">
          <el-link type="primary" @click="showTaxInformationAddList" >添加</el-link>
        </div>
      </div>
  <div class="bsp-table" style="padding:10px 40px">
      <bsp-table
        ref="custPaybanksetTable"
        :data.sync="taxInformationList"
        :ciic-data-filter.sync="taxInformationlistQuery"
        :showPagination="false"
        @ciic-data-refresh="_getTaxInformationListpage"
        v-loading="loading"
        min-height="200"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        show-overflow>
        <!--<vxe-table-column type="selection" width="60" fixed="left" align="center"></vxe-table-column>--><!-- :showPagination="false" 分页
        style="width:1200px;"-->
        <vxe-table-column fixed="left" type="index" title="序号" width="60" ></vxe-table-column>
        <bsp-table-column field="id"  filter-type="input" sortable :visible="false">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </bsp-table-column>
        <bsp-table-column field="enterpriseName" fixed="left" title="纳税专户名称" width="120" ><!--:showPagination="false"-->
          <template slot-scope="scope">
            <span>{{ scope.row.taxCompanyName }}</span>
          </template>
        </bsp-table-column>
        <bsp-table-column field="taxpayerIdentinum" title="纳税人识别号" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.taxpayerIdNum}}</span>
          </template>
        </bsp-table-column>
        <bsp-table-column field="orgId" title="所属机构"  width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.orgId | bspTableFilter({'1':'refs','3':orgMap})}}</span>
          </template>
        </bsp-table-column>
        <bsp-table-column field="enterpriseArea" title="企业所属行政区" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.wageAreaCode | bspTableFilter({'1':'dict','2':dicts}) }}</span>
          </template>
        </bsp-table-column>
        <bsp-table-column field="areaNumber" title="行政区划代码" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.areaCode }}</span>
          </template>
        </bsp-table-column>
        <bsp-table-column field="realnameAccount" title="报税实名账号" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.realnameAccount }}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column field="realnamePassword" title="实名密码" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.realnamePwd }}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column field="registNum" title="主管税务机关登记序号ID" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.registNum }}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column field="nettaxUsername" title="网税系统用户名" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.nettaxUsername }}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column field="taxDeclaePwd" title="申报密码" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.taxDeclaePwd }}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column field="taxDeclaeAccount" title="电子报税账户号" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.taxDeclaeAccount }}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column field="taxDeclareMethod" title="税金申报方式" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.taxDeclareMethod | bspTableFilter({'1':'dict','2':dicts}) }}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column field="taxDeclaeAccount" title="部门编号" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.deptNum }}</span>
          </template>
        </bsp-table-column>
        <bsp-table-column field="status" title="状态" width="120">
          <template slot-scope="scope">
            <span>{{scope.row.status |bspTableFilter({'1':'dict', '2':dicts})}}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column title="操作" fixed="right" width="200"><!--fixed="left"  align="center"-->
          <template slot-scope="scope">
            <div class="ciic-table-operate" >
              <el-button type="text"   @click="taxInformationEditRow(scope.row)">编辑</el-button>
              <el-button type="text"   @click="changeStatus(scope.row,status.ENABLE)">启用</el-button>
              <el-button type="text"   @click="changeStatus(scope.row,status.DISABLED)">禁用</el-button>
            </div>
          </template>
        </bsp-table-column>
      </bsp-table>

  </div>
    </div>

    <!--    计薪规则信息新增弹窗-->
    <el-dialog ref="cusPaysetDialog" width="1000px" v-dialogDrag :close-on-click-modal="false" :close-on-press-escape="false" :title="textMap[dialogStatus]" :visible.sync="cusPaysetFormVisible" v-loading="loading">
      <cusPaysetForm ref="cusPaysetForm" :list-form.sync="listForm"></cusPaysetForm>
      <div class="marginTop30" style="text-align: center">
        <el-button type="primary" @click="handlerCusPaysetListForm" > 保存 </el-button>
        <el-button @click="cusPaysetFormVisible = false"> 取消 </el-button>
      </div>

    </el-dialog>

    <!--    付款方信息新增弹窗-->
    <el-dialog ref="cusPaybanksetDialog" width="1000px" v-dialogDrag :close-on-click-modal="false" :close-on-press-escape="false" :title="textMap[dialogStatus]" :visible.sync="cusPaybanksetFormVisible" v-loading="loading">
      <cusPaybanksetForm ref="cusPaybanksetForm" :list-form.sync="cusPaybanksetListForm"></cusPaybanksetForm>
      <div class="marginTop30" style="text-align: center">
        <el-button type="primary" @click="handlerCusPaybanksetListForm" > 保存 </el-button>
        <el-button @click="cusPaybanksetFormVisible = false"> 取消 </el-button>
      </div>

    </el-dialog>

    <!--    公司税务信息新增弹窗-->
    <el-dialog ref="taxInformationDialog" width="1000px" v-dialogDrag :close-on-click-modal="false" :close-on-press-escape="false" :title="textMap[dialogStatus]" :visible.sync="taxInformationFormVisible" v-loading="loading">
      <taxInformationForm ref="taxInformationForm" :list-form.sync="taxInformationListForm"></taxInformationForm>
      <div class="marginTop30" style="text-align: center">
        <el-button type="primary" @click="handlertaxInformationListForm" > 保存 </el-button>
        <el-button @click="taxInformationFormVisible = false"> 取消 </el-button>
      </div>

    </el-dialog>

  </div>
</template>

<script>
  import BspTable from "@/components/bsp/bsp-table/bsp-table";
  import BspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
  import cusPaybanksetForm from "./companyInfoForm/cus-paybankset-form";
  import cusPaysetForm from "./companyInfoForm/cus-payset-form";
  import taxInformationForm from "./companyInfoForm/tax-information-form";
  import { mapGetters } from 'vuex';
  import {getCusPaysetList,getCusPaybanksetList,addCusPaybanksetList,updateCusPaybanksetList,deleteCusPaybanksetData,getTaxInformationList,addTaxInformationList,updateTaxInformationList,updateEnableOrDisabled,addCusPaysetList,updateCusPaysetList,deleteCusPaysetData} from  "@/api/wage/companyTemplate";
  import store from "@/store";
  import {getCompanyOrg} from "@/api/org/org";
  import {commonConst} from "@/const/code"
  import {deepCopy} from "@/util/util";
  import {queryPmsPayGroupTree,getGroupTree} from "@/api/wage/payGroup";
  export default {
    name: "companyInfo",
    components:{
      cusPaybanksetForm,
      cusPaysetForm,
      taxInformationForm,
      BspTable,
      BspTableColumn,
    },
    computed: {
      ...mapGetters([
        'dicts',
      ]),
    },
    data(){
      return{
        role:{
          name: 'admin',
          tenantId: 'sys'
        },
        status:{
          ENABLE:commonConst.ENABLE,//启用
          DISABLED:commonConst.DISABLED,//禁用
        },
        dialogItem:false,
        dialogItemIndex:[],
        dialogTypeIndex:null,
        dialogType:false,
        popVisible:[],//下拉框是否显示
        opens:[],//是否收起
        list:[],
        orgMap:{},//组织结构map
        cusPaybanksetList:[],
        taxInformationList:[],
        loading:false,
        //分页查询对象
        listQuery: {
          limit: 5,
          page: 1,
          total: 0,
          tenantId: '',
        },
        taxInformationlistQuery: {
          limit: 10,
          page: 1,
          total: 0,
          tenantId: '',
        },
        rules: {
          1234567: [
            { required: true, message: '请输入模板名称', trigger: 'blur' },
            { min: 4, max: 40, message: '长度在 4 到 40 个字符', trigger: 'blur' }
          ]
        },
        showSys:true,
        id:'',
        listForm:{
        },
        cusPaybanksetListForm:{
        },
        taxInformationListForm:{
          fileIds:'',
          photo:'',
          fileId:'',
        },
        textMap: {
          addCusPayset: '新增计薪周期',
          updateCusPayset: '编辑计薪周期',
          addCusPaybankset: '新增发薪银行',
          updateCusPaybankset: '编辑发薪银行',
          addTaxInformation: '新增税务信息',
          updateTaxInformation: '编辑税务信息'
        },
        dialogStatus: 'addCusPayset',
        dialogFormVisible: false,
        cusPaybanksetFormVisible: false,
        cusPaysetFormVisible: false,
        taxInformationFormVisible: false,
        typeForm: {
          id:'',
          name: "",
          typeTextarea: "",
          self:true,
          data:{}
        },
        itemForm:{
          id:'',
          name:"",
          itemSelect:'',
          itemRadio:1,
          itemTextarea:''
        },
        options: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
        payGroupMap:{}
      }
    },
    created(){
      /*const len = this.lists.length;
      for(var i = 0;i<len;i++){
        this.popVisible.push({visible:false})
        this.opens.push({open:true})
      }*/

      //console.log("==============================="+JSON.stringify(store.getters.dicts) )
      this._getCusPaysetListpage();
      this._getCusPaybanksetListpage();
      this._getTaxInformationListpage();
      //调用方法获取组织机构
      this._getCompanyOrg(store.getters.cusId);
      this.queryPmsPayGroupTree();
    },
    methods:{
      _getCompanyOrg(cusId){
        getCompanyOrg(cusId).then(res=>{
          let orgData = res.data;//查询机构树
          let map = {};
          for (let i = 0,l=orgData.length; i <l; i++) {
            map[orgData[i].id]=orgData[i].orgName;//id:orgName结构存储
          }
          this.orgMap =  map;
        })
      },
      queryPmsPayGroupTree(){
        //前台翻译 查询用户下的所有薪酬组
        getGroupTree({}).then(res=>{
          let list = res.data.data ;
          let map = {};
          for (let i = 0,l=list.length; i <l; i++) {
            let item = list[i];
            map[item.id]=item.groupName;//id:orgName结构存储
            for (let j in item.children) {
              let child = item.children[j];
              map[child.id]=child.groupName;
              for (let a in child.children) {
                let childer = child.children[a];
                map[childer.id]=childer.groupName;
              }
            }
          }
          this.payGroupMap = map;//查询薪酬组树
          console.log(list)
        })
      },
      //计薪删除
      cusPaysetDeleteRow(row){
        this.$confirm('是否确认删除?', '提示',{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(()=>{
          this.id = row.id;
          deleteCusPaysetData(this.id).then(res=>{
            this.$message.success("删除成功");
            this._getCusPaysetListpage();
          })
        });
      }, //付款删除
      cusPaybanksetDeleteRow(row){
          this.$confirm('是否确认删除?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              this.id = row.id;
              deleteCusPaybanksetData(row.id).then(res=>{
                  this.$message.success("删除成功");
                  this._getCusPaybanksetListpage();
              })
          });
      },
      //计薪编辑
      cusPaysetEditRow(row){
        //展示编辑表单框
        this.cusPaysetFormVisible = true
        this.dialogStatus='updateCusPayset'
        this.listForm = {}
        if(this.$refs.cusPaysetForm){
          this.$nextTick(()=>{
            this.$refs.cusPaysetForm.$refs.listForm.clearValidate();//新增前清空校验
          // this.$refs.cusPaysetForm.clearTreeSelect();//清空下拉选择
          })
        }
        this.listForm = deepCopy(row)
      },
       //付费编辑
      cusPaybanksetEditRow(row){
        //展示编辑表单框
          this.cusPaybanksetFormVisible = true
          this.dialogStatus='updateCusPaybankset'
          this.cusPaybanksetListForm = {};
          if(this.$refs.cusPaybanksetForm){
            this.$refs.cusPaybanksetForm.$refs.listForm.clearValidate();
            this.$refs.cusPaybanksetForm.$refs.ifDefault.selectedData = row.ifDefault
            this.$refs.cusPaybanksetForm.$refs.payerBankType.selectedData = row.payerBankType
          }

          this.cusPaybanksetListForm = deepCopy(row)
      }, //公司税务信息编辑
      taxInformationEditRow(row){
        //展示编辑表单框
        this.taxInformationFormVisible = true
        this.dialogStatus='updateTaxInformation'
        this.taxInformationListForm = {};

        if(this.$refs.taxInformationForm){
          this.$refs.taxInformationForm.$refs.listForm.clearValidate();
          this.$refs.taxInformationForm.$refs.taxDeclareMethod.selectedData = row.taxDeclareMethod
          this.$refs.taxInformationForm.$refs.isDept.selectedData = row.isDept
          this.$refs.taxInformationForm.selectChange(row.isDept)
        }
        console.log(row.wageAreaCode)

        this.taxInformationListForm = deepCopy(row)
        this.taxInformationListForm.wageAreaCode = '10260010'
        this.$nextTick(()=>{
          this.taxInformationListForm.wageAreaCode = row.wageAreaCode
        })

      },
      //计薪查询
      _getCusPaysetListpage(){
        this.loading = true;
        // alert("计薪查询");
        getCusPaysetList(this.listQuery).then((res) => {
          this.listQuery.total = res.data.total
          this.list = res.data.records
          this.loading=false
        }).catch(err=>{
          this.loading=false
        })
      },//付款方信息查询
      _getCusPaybanksetListpage(){
        this.loading = true;
        getCusPaybanksetList(store.getters.cusId).then((res) => {
          console.log('2222')

          this.cusPaybanksetList = res.data;
          this.loading=false
        }).catch(err=>{
          this.loading=false
        });
      },//公司税务方信息查询
      _getTaxInformationListpage(){
        this.loading = true;
        // alert("计薪查询");
        getTaxInformationList(this.taxInformationlistQuery).then((res) => {
          this.taxInformationlistQuery.total = res.data.total
          this.taxInformationList = res.data.records
          this.loading=false
        }).catch(err=>{
          this.loading=false
        })
      },
      //启用和禁用方法
      changeStatus(row,status){
        console.log(row)
        let param={
          id: row.id,
          cusId:store.getters.cusId,
          status: status
        }
        if(row.status == status){
          this.$message.warning('该设置已'+(status=='90110002'?'禁用':'启用'));
          return;
        }
        this.loading = true;
        updateEnableOrDisabled(param).then(res =>{
          this.loading = false;
          if(res.data.code==0){
            this.$message.success('操作成功');
          }
          this._getTaxInformationListpage();
        }).catch(err=>{
          this.loading=false
        })
      },
      //计薪保存方法:
      handlerCusPaysetListForm(){
        let childForm = this.$refs.cusPaysetForm.$refs.listForm
        if (this.dialogStatus == 'addCusPayset') {
          childForm.validate((valid) => {
            if (valid) {
              this.loading = true;
              addCusPaysetList(this.listForm).then(res => {
                this.loading = false;
                if(res.data.code==0){

                  this.cusPaysetFormVisible = false
                  this.$message.success('新增成功');
                }
                this._getCusPaysetListpage();
              }).catch(err=>{
                this.loading=false
              })
            }
          });
        } else if (this.dialogStatus == 'updateCusPayset') {
          childForm.validate((valid) => {
            this.loading = true;
            if (valid) {
              updateCusPaysetList(this.listForm).then(res => {
                this.loading = false;
                if(res.data.code==0){
                  this.cusPaysetFormVisible = false
                  this.$message.success('修改成功');
                }
                this._getCusPaysetListpage();
              }).catch(err=>{
                this.loading=false
              })
            }
          })
        }
      }, //付款保存方法:
      handlerCusPaybanksetListForm(){
        let childForm = this.$refs.cusPaybanksetForm.$refs.listForm
        if (this.dialogStatus == 'addCusPaybankset') {
          childForm.validate((valid) => {
            if (valid) {
              this.loading = true;
              addCusPaybanksetList(this.cusPaybanksetListForm).then(res => {
                if(res.data.code==0){
                  this.loading = false;
                  this.cusPaybanksetFormVisible = false
                  this.$message.success('新增成功');
                }
                this._getCusPaybanksetListpage();
              }).catch(err=>{
                this.loading=false
              })
            }
          });
        } else if (this.dialogStatus == 'updateCusPaybankset') {
          childForm.validate((valid) => {
            if (valid) {
              this.loading = true;
              updateCusPaybanksetList(this.cusPaybanksetListForm).then(res => {
                this.loading = false;
                if(res.data.code==0){
                  this.cusPaybanksetFormVisible = false
                  this.$message.success('修改成功');
                  this._getCusPaybanksetListpage();
                }/*else{
                  this.$message({ type: "error", message: res.data.msg });
                }*/

              }).catch(err=>{
                this.loading=false
              })
            }
          })
        }
      },//公司税务保存方法:
      handlertaxInformationListForm(){
        //这个refs就是ref
        let childForm = this.$refs.taxInformationForm.$refs.listForm
        console.log('税务信息保存方法：', JSON.parse(JSON.stringify(this.taxInformationListForm)))
        if (this.dialogStatus == 'addTaxInformation') {
          childForm.validate((valid) => {
            if (valid) {
              this.loading = true;
              addTaxInformationList(this.taxInformationListForm).then(res => {
                this.loading = false;
                if(res.data.code==0){
                  this.taxInformationFormVisible = false
                  this.$message.success('新增成功');
                  this._getTaxInformationListpage();
                }
              }).catch(err=>{
                this.loading=false
              })
            }
          });
        } else if (this.dialogStatus == 'updateTaxInformation') {
          childForm.validate((valid) => {
            if (valid) {
              this.loading = true;
              updateTaxInformationList(this.taxInformationListForm).then(res => {
                this.loading = false;
                if(res.data.code==0){
                  this.taxInformationFormVisible = false
                  this.$message.success('修改成功');
                  this._getTaxInformationListpage();
                }
              }).catch(err=>{
                this.loading=false
              })
            }
          })
        }
      },
      changeOpen(index){
        this.$set(this.opens[index],"open",!this.opens[index].open)
      },
      changeItem(checked,index){// checked是所有的选中值，index是当前选择框组的序号,当前选择组为checked[index]
        console.log(checked[index])
      },
      // 新增行
      addItem(index){
        this.dialogItem = true
        this.dialogItemIndex = [index,this.lists[index].data.length]
      },
      //展示发薪信息新增表格
      showCustPaysetAddList(){
        this.cusPaysetFormVisible = true
        this.listForm = {}
        if(this.$refs.cusPaysetForm){
          this.$refs.cusPaysetForm.clearTreeSelect();//清空下拉选择
          this.$nextTick(()=>{
            this.$refs.cusPaysetForm.$refs.listForm.clearValidate();//新增前清空校验
          })
        }
        this.dialogStatus='addCusPayset'
      },
      //展示付款方信息新增表格
      showCustPaybanksetAddList(){
        // this.$refs.cusPaybanksetForm.cusPaybanksetListForm = {}
        // Object.assign(this.cusPaybanksetListForm,this.cusPaybanksetListFormCopy);
        this.cusPaybanksetListForm={}
        if(this.$refs.cusPaybanksetForm){
          this.$refs.cusPaybanksetForm.$refs.listForm.clearValidate();
          this.$refs.cusPaybanksetForm.$refs.ifDefault.selectedData = ""
          this.$refs.cusPaybanksetForm.$refs.payerBankType.selectedData = ""
        }
        this.cusPaybanksetFormVisible = true;
        this.dialogStatus='addCusPaybankset'
      },

      //展示公司税务信息新增表格
      showTaxInformationAddList(){
        this.taxInformationListForm={}//新增前清空
        if(this.$refs.taxInformationForm){
          this.$refs.taxInformationForm.$refs.listForm.clearValidate();//新增前清空校验
          this.$refs.taxInformationForm.$refs.taxDeclareMethod.selectedData = ""
          this.$refs.taxInformationForm.$refs.isDept.selectedData = "10020002"
          this.$refs.taxInformationForm.isDeptNum = false
        }
        this.taxInformationListForm['isDept'] = '10020002'
        this.taxInformationFormVisible = true
        this.dialogStatus='addTaxInformation'
      },

      // 编辑行
      salaryEdit(index,itemIndex){
        this.$set(this.itemForm,"id",this.lists[index].data[itemIndex].id)
        this.$set(this.itemForm,"name",this.lists[index].data[itemIndex].name)
        this.$set(this.itemForm,"itemTextarea",this.lists[index].data[itemIndex].explain)
        this.$set(this.itemForm,"itemSelect",this.lists[index].data[itemIndex].type)
        this.$set(this.itemForm,"itemRadio",this.lists[index].data[itemIndex].fixed)
        this.dialogItem = true
        this.dialogItemIndex = [index,itemIndex]
      },
      // 编辑类别
      editType(index){
        this.dialogType = true
        this.$set(this.typeForm,"id", this.lists[index].id);
        this.$set(this.typeForm,"name", this.lists[index].title);
        this.$set(this.typeForm,"itemTextarea" , this.lists[index].remark);
        this.$set(this.typeForm,"self" ,  this.lists[index].self);
        this.$set(this.typeForm,"data" ,  this.lists[index].data);
        this.dialogTypeIndex=index
      },
      dialogItemClose(){
        this.$refs.itemForm.resetFields();
        this.dialogItem = false
      },
      dialogTypeClose(){
        this.$refs.typeForm.resetFields();
        this.dialogType = false
      },
      // 保存一行
      dialogItemSave(){
        // 保存
        let [index,itemIndex] = this.dialogItemIndex;
        let data = {}
        data.id = this.itemForm.id;
        data.name = this.itemForm.name;
        data.type = this.itemForm.itemSelect;
        data.fixed = this.itemForm.itemRadio;
        data.explain = this.itemForm.itemTextarea;
        data.formula = "";
        data.btn = 2 ;// 可编辑
        this.$set(this.lists[index].data,itemIndex,data)

        this.$refs.itemForm.resetFields()
        this.dialogItem = false
      },
      //新增分类
      addType(){
        this.dialogType = true
        this.dialogTypeIndex = this.lists.length
      },
      // 保存分类
      dialogTypeSave(){
        // 保存
        let index = this.dialogTypeIndex;
        let data = {}
        data.id = this.typeForm.id;
        data.title = this.typeForm.name;
        data.remark = this.typeForm.itemTextarea;
        data.self = true;
        data.data = this.typeForm.data;
        this.$set(this.lists,index,data)
        this.$set(this.popVisible,index,{visible:false})
        this.$set(this.opens,index,{open:true})
        const checkList ={
          id:'check4',
          checkList:[{id:'d1',value:'雇员编号1'},{id:'d2',value:'证件类型'},{id:'d3',value:'银行卡开户名'},{id:'d4',value:'银行卡账号'},{id:'d5',value:'银行类别'}]
        }
        this.$set(this.checkLists,index,checkList)
        this.$set(this.checked,index,[])
        this.$refs.typeForm.resetFields();
        this.dialogType = false
      },
      // 删除一行
      deleteData(index,indexItem){
        this.lists[index].data.splice(indexItem, 1);
      },
      // 删除类别
      deleteType(index){
        this.lists.splice(index, 1);
      },
    }
  };
</script>

<style scoped>
  .el-switch{
    margin-top: 0;
  }
  .salaryItem{
    padding:0 20px;
  }
  .salaryItemHeader{
    display: flex;
    margin-top: 20px;
    background-color: #efefef;
    line-height: 40px;
    color:#999;
    font-size: 16px;
    padding-left: 34px;
    padding-right: 30px;
    display: flex;
    justify-content: space-between;
  }
  .salaryItemHeaderL{
    padding-left: 26px;
  }
  .salaryItemHeaderR{
    display: flex;
    justify-content: flex-end;
    color:#bbbbbb;
  }
  .salaryCheck{
    margin-right: 25px;
    padding: 0 5px;
  }
  .salaryCheckActve{
    background-color: #fff;
  }
  .salaryLine{
    border-bottom:1px solid #efefef;
    line-height: 40px;
    padding: 0 30px 0 34px;
  }
  .salaryLine svg{
    font-size: 16px;
  }
  .salaryTitle svg{
    margin-right: 10px;
  }
  .salaryTitle .zhanwei{
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
  .salaryTitle{
    color:#000000;
    font-size: 14px;
    display: flex;
    align-items: center;
  }
  .salaryTitle svg{
    color:#FF9600;
  }
  .salaryExplain{
    font-size: 12px;
    color: #999999;
    padding: 10px;
    line-height: 20px;
  }
  .salaryFormula {
    color: #008AFF;
    font-size: 12px;
    cursor: pointer;
  }
  .hasFormula{
    color:#999999;
    cursor: auto;
  }
  .salaryFormula svg{
    margin-right: 10px;
    color:#008AFF;
  }
  .hasFormula svg{
    color:#75CF00;
  }
  .salaryBtn{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 40px;
    color:#008AFF;
  }
  .salaryBtnEdit{
    margin-right: 30px;
  }
  .salaryBtn svg{
    cursor: pointer;
  }
  .salaryItemHeaderC{
    color: #999999;
    font-size: 12px;
  }
  .salaryItemHeaderR div{
    cursor: pointer;
    margin-right: 30px;
  }
  .salaryItemHeaderR div:last-child{
    margin-right: 0px;
  }

  .addItem{
    margin: 20px auto 0;
    width: 160px;
    height: 30px;
    background-color: #DDDDDD;
    border-radius: 20px;
    font-size: 12px;
    color:#008AFF;
    align:center;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .addItem svg{
    margin-right: 10px;
    font-size: 16px;
  }
  .salaryChecks>>>.el-checkbox{
    display: flex;
    align-items: center;
    margin-right: 0;
  }
  .salaryChecks>>>.el-checkbox__label{
    line-height: 26px;
    color:#000000;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 120px;
  }
  .salaryChecks>>>.el-checkbox__input{
    margin-top: 2px;
  }
  .addCheck{
    cursor: pointer;
    width: 120px;
    height: 30px;
    font-size: 12px;
    color:#008AFF;
    background: #EFEFEF;
    border-radius: 20px;
    text-align: center;
    line-height: 30px;
    margin: 10px auto 0;
  }
  .el-radio-group{
    margin: 0;
    height: 30px;
    display: flex;
    align-items: center;
  }
</style>
<style>
  .salaryCheckPop{
    min-width: 120px;
  }
  .salaryCheckPop .popper__arrow{
    display: none;
  }
  .bsp-table{
    padding: 10px 40px;
  }
</style>
